import React, { useState, useEffect, useRef } from 'react';
import CustomAutocomplete from 'components/CustomAutocomplete';
import PropTypes from 'prop-types';
import CMS from 'services/CMS';
import Loader from 'components/Loader';
import PubSub from 'services/PubSub';
import AddressService from 'services/Address';
import StorageService from 'services/StorageService';
import TagManagerService from 'services/TagManager';
import ExpressDeliveryService from 'services/ExpressDelivery';
import {expressFlag} from 'config';
import AddressMap from './AddressMap';
import { cleanSearch,cleanAddress, removeEmojis } from 'utils';
import { useViewportMediaQuery } from 'hooks';
import { actionsType } from 'config/constants';
import NewRelicService from 'services/NewRelic'
import style from './style.scss';//NOSONAR

let googlePlace = {};
let place = {};
let initialGeocordinate = null;
let _address = {};
let states = [];
let actions = [];

const AddressSelect = (props) => {
    const addressEditable = props.editAddress ? !!props.editAddress.addressId : null;
    const isMobile = useViewportMediaQuery('768');

    const [bounds] = useState(null);
    const [address, setAddress] = useState({});
    const [isNotGeoreference, setNotGeoreference] = useState(false);
    const [isNotFoundNeighborhood, setNotFoundNeighborhood] = useState(false);
    const [streetInvalid, setStreetInvalid] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [express, setExpress] = useState(false);
    const [withReference, setWithReference] = useState(false);
    const [resume, setResume] = useState(false);
    const [fullText, setFullText] = useState(addressEditable ? props.editAddress.street + (props.editAddress.number ? ' ' + props.editAddress.number : '') : '');
    const numberRef = useRef(null);
    const streetRef = useRef(null);

    useEffect(() => {
        CMS.getOperationsV2().then(data => {

            if (!data) {
                data = {};
            }
            states = data.states || [];
            _address.complement = null;
            setLoading(false);
            _editAddress();
        });

        actions.push(PubSub.register('address_autocomplete_is_empty', _statusAutocomplete));
        actions.push(PubSub.register('address_reference_change', _changeAddressReference));
        

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
            _address = {}
            PubSub.dispatch('change_title_modal', {changeTitle: false});
        }
    }, []);

    const notGeoreference = () => {
        setStreetInvalid(false);
        setNotGeoreference(true);
        setNotFoundNeighborhood(false);
        
        PubSub.dispatch('autocomoplete_clean');

        _sendPageEvent('changeToReference', null);
    }

    const _editAddress = () => {
        if (!addressEditable) return false;

        _address = { ...props.editAddress };

        const placeAddress = { ..._address };

        place = {
            route: placeAddress.street,
            'street_number': placeAddress.number,
            locality: placeAddress.neighborhood,
            'administrative_area_level_1': placeAddress.state,
            'administrative_area_level_2': placeAddress.city,
            'administrative_area_level_3': placeAddress.neighborhood,
            complement: placeAddress.complement,
            reference: placeAddress.reference
        };

        const neighborhoodData = _veriryNeighborhood(place, true);
        _address.neighborhood = neighborhoodData.neighborhood;
        _address.state = neighborhoodData.state;

        _setAddress(_address);
        if (_address.reference) setWithReference(true);

        //actions.push(PubSub.register('google_maps_init', _applyInitialPosition));
        _applyInitialPosition();
    };

    const _applyInitialPosition = () => {
        AddressService.getGeocode(_getFullAddress(_address)).then(data => {
            if (data) {
                const location = data.geometry.location;
                const viewport = _getViewportBounds(data.geometry.viewport);

                googlePlace = {
                    geometry: {
                        viewport,
                        location: new google.maps.LatLng(location.lat, location.lng)
                    }
                }
            }
        });
    }

    const _getViewportBounds = (viewport) => {
        let boundsLimit = new google.maps.LatLngBounds();
        boundsLimit.extend(new google.maps.LatLng(viewport.northeast));
        boundsLimit.extend(new google.maps.LatLng(viewport.southwest));

        return boundsLimit;
    }

    const _statusAutocomplete = (payload) => {
        const { isEmpty } = payload.value;
        setStreetInvalid(isEmpty);
    };

    const onSubmit = (event) => {
        event.preventDefault();
    };

    const addressSelected = (placeSelected, isReference) => {
        _changePlace(placeSelected, isReference);
    };

    const _factoryGoogleAddress = (selectedPlace) => {
        if (!selectedPlace) return false;
        let results = {};

        selectedPlace.address_components.map(item => {
            item.types.map(type => {
                results[type] = item.long_name;
            });
        });

        if (results.country !== 'Chile') {
            return null;
        }
        return results;
    };

    const _changeAddressReference = (payload) => {
        if (!(initialGeocordinate && initialGeocordinate[0])) return false;
        const { latLng } = payload.value;
        const distance = AddressService.getAddressDistance(latLng, new google.maps.LatLng(initialGeocordinate[1], initialGeocordinate[0]));
        const kmMax = _address.state === 'REGIÓN METROPOLITANA' ? (_validSkiCenter(_address.neighborhood) ? 15 : 1) : 25;

        if (distance > kmMax) {
            setTimeout(() => {
                PubSub.dispatch('address_reference_change_out_limit', {
                    location: latLng
                });
            });
            _address.geoCoordinate = null;
            _setAddress(_address);
            return false;
        }

        _geoCoder(latLng);
    };

    const _geoCoder = (latLng) => {
        const geocoder = new google.maps.Geocoder;
        geocoder.geocode({
            location: latLng,
        }, (response) => {
            response = response ? response.filter(addressP => addressP.address_components.filter(component => component.types.indexOf('route') !== -1).filter(Boolean).length > 0).filter(Boolean) : [];
            if (!response && response.length != 0) return false;
            const addresses = response.filter(item => item.types.indexOf('geocode') === -1);
            if (!place.route) {
                const addressFirts = addresses[0];
                const addressComponents = _factoryGoogleAddress(addressFirts);
                place.street_number = null;

                _address.city = _getCity(addressComponents);
                _address.geoCoordinate = [addressFirts.geometry.location.lng(), addressFirts.geometry.location.lat()];
                _address.addressName = _address.addressId || _getAddressName();

                _setAddress(_address);
                setNotGeoreference(true);
                setStreetInvalid(false);
            } else {
                let isOtherStreet = true;
                addresses.map(addressFirts => {
                    const addressComponents = _factoryGoogleAddress(addressFirts);
                    if (!addressComponents) return false;
                    const addressReference = {
                        street: addressComponents.route,
                        number: addressComponents.street_number,
                        neighborhood: _getNeighborhood(addressComponents),
                        city: _getCity(addressComponents),
                        state: addressComponents.administrative_area_level_1 || 'Chile'
                    };

                    if("Región Metropolitana" === addressReference.state){
                        if(addressReference.street.toLocaleLowerCase() === _address.street.toLocaleLowerCase()){
                            isOtherStreet = false;
                        }
                    } else{
                        isOtherStreet = false;
                    }
                });

                _address.geoCoordinate = [latLng.lng(), latLng.lat()];

                if (isOtherStreet) {
                    _address.geoCoordinate = null;

                    PubSub.dispatch('address_reference_change_other_street', {
                        location: latLng
                    });
                }

                _setAddress(_address);
            }
        })
    };

    const _getNeighborhood = (addressComponents) => {
        return addressComponents.locality || addressComponents.administrative_area_level_3 || addressComponents.administrative_area_level_2;
    };

    const _getCity = (addressComponents) => {
        return addressComponents.administrative_area_level_2 || addressComponents.administrative_area_level_1;
    };

    const _validSkiCenter = (neighborhood) => {
        const SkiCenters = ['El Colorado', 'Farellones', 'La Parva', 'Valle Nevado'];

        return SkiCenters.indexOf(neighborhood) !== -1;
    };

    const _isNeighborhood = (value, addressComponents) => {
        const locality = addressComponents.locality ? addressComponents.locality.toLocaleLowerCase() : '';
        const level2 = addressComponents['administrative_area_level_3'] ? addressComponents['administrative_area_level_3'].toLocaleLowerCase() : '';
        const valueNormalized = cleanSearch(value);
        const localityNormalized = cleanSearch(locality);
        const level2Normalized = cleanSearch(level2);

        return (localityNormalized && valueNormalized.indexOf(localityNormalized) !== -1) || (level2Normalized && valueNormalized.indexOf(level2Normalized) !== -1);
    };

    const _veriryNeighborhood = (placeSelected, isComponents = false) => {
        const addressComponents = isComponents ? placeSelected : _factoryGoogleAddress(placeSelected);
        let result = {};

        const translate = {
            state: {
                'metropolitana': 'metropolitana de santiago'
            }
        }

        let state = addressComponents['administrative_area_level_1'].toLocaleLowerCase().replace('región del ', '').replace('región de ', '').replace('región ', '');
        state = translate.state[state] || state;
        let neighborhoodSelected = false;

        states.map(item => {
            const itemLabel = cleanSearch(item.name.toLocaleLowerCase());
            const itemValue = cleanSearch(item.value.toLocaleLowerCase());
            const stateNormalized = cleanSearch(state);

            if (itemLabel.indexOf(stateNormalized) !== -1 || itemValue.indexOf(stateNormalized) !== -1) {
                result.state = {
                    label: item.name,
                    value: item.value
                };
                item.cities.map(city => {
                    if (!neighborhoodSelected && _isNeighborhood(city.name.toLocaleLowerCase(), addressComponents)) {
                        result.neighborhood = city;
                        neighborhoodSelected = true;
                    }
                });
            }
        });

        return result.state && result.neighborhood ? result : null;
    };

    const _getAddressName = () => {
        return (Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)) + new Date().getTime();
    };

    const _sendPageEvent = (status = '', data = null, action = null) => {
        try{
            NewRelicService.sendPageAction({
                action: action || 'modalAddress',
                payload: {
                    status,
                    streetNumber: data ? (data.street_number || data.number) : null,
                    locality: data ? (data.locality || (data.neighborhood ? data.neighborhood.name : null)) : null,
                    street: data ? (data.route || data.street) : null,
                    found: data ? data.found : null
                }
            })
        } catch (e){
            return false;
        }
    }

    const _changePlace = ($place, $isReference) => {
        if (!($place && $place.geometry)) return false;
        googlePlace = { ...$place };
        place = _factoryGoogleAddress($place);

        _sendPageEvent('selectPlace', place);

        const neighborhoodData = _veriryNeighborhood($place);

        if (!neighborhoodData) {
            setNotFoundNeighborhood(true);
            return false;
        }

        if (place) {
            if (!$isReference) {
                _address.city = place.administrative_area_level_2;
                _address.geoCoordinate = place.street_number ? [$place.geometry.location.lng(), $place.geometry.location.lat()] : null;
                _address.addressName = _address.addressId || _getAddressName();
            } else {
                place.route = null;
            }

            _address.street = !$isReference ? place.route : null;
            place.street_number = !$isReference ? place.street_number : null;
            _address.number = place.street_number;
            _address.state = neighborhoodData.state;
            _address.neighborhood = neighborhoodData.neighborhood;
            initialGeocordinate = [$place.geometry.location.lng(), $place.geometry.location.lat()];

            _setAddress(_address);
            setNotGeoreference($isReference);

            if(!_address.street || _address.street.length === 0){

                streetRef.current.focus();

            } else if(!_address.number){

                numberRef.current.focus();

            }

            setStreetInvalid(false);
            setNotFoundNeighborhood(false);
            setFullText($place.name);
        }
    };

    const _getFullAddress = (addresses) => {
        let addressArray = [];

        addressArray.push(addresses.street);
        addressArray.push(addresses.number);
        if (addresses.complement) addressArray.push(addresses.complement);
        addressArray.push(addresses.neighborhood.name);
        addressArray.push(addresses.state.label);

        return addressArray.join(', ');
    };

    const clearAddress = () => {
        if (!place) return false;
        _address.street = null;
        place.street_number = null;
        _address.number = place.street_number;
        _address.geoCoordinate = false;
        _address.state = null;
        _address.neighborhood = null;
        _address.reference = null;

        _setAddress(_address);
        setExpress(false);
        setNotFoundNeighborhood(false);
    };

    const _setAddress = ($address) => {
        setAddress({ ...$address });
        if(expressFlag && $address.geoCoordinate){
            _validateExpress($address.geoCoordinate);
        }
    };

    const _validateExpress = (geoCoordinate) => {
        const lat = geoCoordinate[1];
        const lng = geoCoordinate[0];

        return ExpressDeliveryService.assignAddress(lat, lng).then(data => {
            if(data && data.express_delivery){
                setExpress('Dirección disponible para Despacho Express');
            } else {
                setExpress(false);
            }
        });
    }

    const updateComplement = (e) => {
        const { value } = e.target;
        _address.complement = removeEmojis(value);
        _setAddress(_address);
    };

    const updateStreetNumber = (e) => {
        _address.number = e.target.value;
        _setAddress(_address);
    };

    const updateStreet = (e) => {
        _address.street = e.target.value;
        _setAddress(_address);
    };

    const updateReference = (e) => {
        const { value } = e.target;

        _address.reference = removeEmojis(value);
        _setAddress(_address);
    };

    const goResume = () => {
        if (!(address.street && address.number)) return false;
        const isReference = isNotGeoreference || !place.street_number;

        if (isReference) {
            _address.geoCoordinate = null;
            _setAddress(_address);
        }

        if(!place.street_number){
            const newAddress = `${_address.number} ${place.route} ${place.locality} ${place.administrative_area_level_1}`;
            geoCode(newAddress);
        }else {
            _sendPageEvent('goToResume', address)
            setResume(true);
            PubSub.dispatch('change_title_modal', {changeTitle: true});
        }
        
    }

    const backToForm = () => {
        PubSub.dispatch('address_close_map');
        setResume(false);
    }

    const _getUpdatedAddress = (_addressSelected) => {
        let addressSelect = { ..._addressSelected };
        address.country = 'CHL';
        address.complement = cleanAddress(addressSelect.complement) || '';
        address.reference = cleanAddress(addressSelect.reference) || '';
        address.receiverName = '';
        address.addressType = 'residential';
        address.postalCode = addressSelect.neighborhood.postalCode;
        address.neighborhood = addressSelect.neighborhood.name;
        address.state = addressSelect.state.value;

        return _addressSelected;
    }

    const saveAddress = () => {
        if (isLoading) return false;

        setLoading(true);

        const _addressSelected = _getUpdatedAddress(address);
        let userData = StorageService.getSecureItem('userData');

        if (userData && userData.email) {

            if (addressEditable) {
                _sendPageEvent('init', null, 'updateAddress');

                AddressService.updateAddress(_addressSelected, userData.id).then(result => {
                    setLoading(false);
                    if (result && result.status === 200) {
                        PubSub.dispatch('address_updated');
                        _sendPageEvent('success', null, 'updateAddress');
                        closeModal();
                    } else {
                        _sendPageEvent('fail', null, 'updateAddress');
                    }
                });
            } else {
                _sendPageEvent('init', null, 'registerAddress');
                AddressService.addAddress(_addressSelected).then(result => {
                    setLoading(false);
                    if (result && result.DocumentId) {
                        PubSub.dispatch('address_added', {
                            addressName: _addressSelected.addressName,
                            documentId: result.DocumentId
                        });
                        TagManagerService.receiveHomeNewAddress('Confirmar');
                        PubSub.dispatch('address_updated', _addressSelected);
                        _sendPageEvent('success', null, 'registerAddress');
                        closeModal();
                    } else {
                        _sendPageEvent('fail', null, 'registerAddress');
                    }
                });
            }
        } else {
            let anonymousAddress = StorageService.getSecureItem('anonymous_address');

            if (!anonymousAddress) {
                anonymousAddress = [];
            }

            anonymousAddress.push(_addressSelected);

            StorageService.setSecureItem('anonymous_address', anonymousAddress);
            PubSub.dispatch('address_updated');
            setLoading(false);
            closeModal();
        }
    }

    const geoCode = (addressCode) => {
        const geoCodeAddress = new google.maps.Geocoder;

        geoCodeAddress.geocode({address: addressCode}, (response) => {
            const newAddress = response[0];
            const addressComponents = _factoryGoogleAddress(newAddress);
            const isReference = (newAddress.types.indexOf('geocode') !== -1);

            if(!isReference && addressComponents && addressComponents.street_number){
                place.street_number = addressComponents.street_number;
                googlePlace = { ...newAddress };
                _address.geoCoordinate = [newAddress.geometry.location.lng(), newAddress.geometry.location.lat()];

                _setAddress(_address);
                setStreetInvalid(false);
                setNotFoundNeighborhood(false);
                setFullText(addressComponents.route + ' ' +  addressComponents.street_number);
                setNotGeoreference(false);
            }

            _sendPageEvent('geoCodeAddress', {
                found: !isReference && addressComponents && !!addressComponents.street_number
            })

            setResume(true);
        });

    }

    const closeModal = () => {
        setTimeout(() => PubSub.dispatch(actionsType.MODAL.ADDRESS_CLOSE))
    }

    const translateRegion = {
        'Metropolitana de Santiago': 'Metropolitana'
    }

    return <form className='modal-address-form new-modal-container ' onSubmit={onSubmit}>
        <div className={"new-modal-scroll" + ((!(resume || withReference)) ? ' not-resume': '')}>
            {!resume && <div className='modal-address-field-group'>
                <label className={'modal-address-field direction requerid' + ((isNotFoundNeighborhood || streetInvalid) ? ' error ' : '')}>
                    <span className='modal-address-label required'>{isNotGeoreference ? 'Lugar de referencia' : 'Dirección'}</span>
                    {isNotGeoreference && <span className='modal-address-example'>Ejemplo: condominio, avenida, supermercado, Colegio, etc.</span>}
                    <CustomAutocomplete onSelected={addressSelected} onChange={clearAddress} value={fullText} bounds={bounds} placeholder={'Calle, número ó referencia'} neighborhood={null} />
                    {isNotFoundNeighborhood && <span className='modal-address-field-error'>La dirección ingresada no tiene cobertura, intenta con otra dirección</span>}
                    {streetInvalid && <span className='modal-address-field-error'>No encontramos tu dirección</span>}
                    {streetInvalid && <div className="address-warning">
                        <span className="address-warning-info">La dirección no aparece en Google Maps, ingresa un lugar de referencia <a onClick={notGeoreference}>aquí</a></span>
                    </div>}
                </label>

                {(isNotGeoreference && (address && address.state)) && <label className={'modal-address-field street requerid' + (!address.street || address.street.length === 0 ? ' highlight ' : '') + (isNotGeoreference ? ' isNotGeoreference' : '')}>
                    <span className='modal-address-label'>Calle</span>
                    <input type="text" defaultValue={address.street || ''} onChange={updateStreet} ref={streetRef} tabIndex={2}/>
                </label>}

                {(isNotGeoreference || address.street) && (address && address.state) && place && !place.street_number && <label className={'modal-address-field number requerid' + (!address.number || address.number.length === 0 ? ' highlight ' : '') + (isNotGeoreference ? ' isNotGeoreference' : '')}>
                    <span className='modal-address-label'>Numero</span>
                    <input type="text" defaultValue={address.number || ''} onChange={updateStreetNumber} ref={numberRef} tabIndex={3}/>
                </label>}

                {address.state && <label className={'modal-address-field complement' + (isNotGeoreference ? ' isNotGeoreference' : '')}>
                    <span className='modal-address-label'>Depto</span>
                    <input type="text" onChange={updateComplement} value={address.complement || ''} tabIndex={3}/>
                </label>}

                <div className="modal-address-field-container">
                    {!!address.state && !!address.neighborhood && <div className='modal-address-field-group'>
                        <label className='modal-address-field inline state'>
                            <span className='modal-address-label'>Región</span>
                            <span className='modal-address-inline-value'>{translateRegion[address.state.label] ? translateRegion[address.state.label] : address.state.label}</span>
                        </label>

                        <label className='modal-address-field inline neighborhood'>
                            <span className='modal-address-label'>Comuna</span>
                            <span className='modal-address-inline-value'>{address.neighborhood.name}</span>
                        </label>
                    </div>}
                    <div className='modal-address-misc'>
                        <div className="modal-address-express-available">{express ? express : ''}</div>
                        {(!withReference && address.state) && <button className='modal-address-add-reference-btn' onClick={()=> setWithReference(true)}>Referencias adicionales</button>}
                    </div>
                </div>
            </div>}

            {resume && (isNotGeoreference || address.street) && place && !place.street_number && <div className='modal-address-map-message'><strong>Mueve el pin</strong> para confirmar tu ubicación.</div>}

            {resume && <AddressMap viewport={googlePlace.geometry.viewport} location={googlePlace.geometry.location} isReference={((isNotGeoreference || address.street) && place && !place.street_number)} />}
            
            {resume && <div className='modal-address-field'>
                <span className='modal-address-label'>Dirección</span>
                <div className='modal-address-resume'>
                    <span className='modal-address-resume-text'>{_getFullAddress(address)}</span>
                    {!isMobile && <button className='modal-address-edit-btn' onClick={backToForm}>Editar</button>}
                </div>
            </div>}
            {resume && <div className='modal-address-misc'>
                <div className="modal-address-express-available">{express ? express : ''}</div>
                {(!withReference && address.state) && <button className='modal-address-add-reference-btn' onClick={()=> setWithReference(true)}>Referencias adicionales</button>}
                {isMobile && <button className={'modal-address-edit-btn' + (withReference ? ' withReference' : '')} onClick={backToForm}>Editar</button>}
            </div>}
            {withReference && <label className='modal-address-field reference'>
                <span className='modal-address-label'>Referencias adicionales</span>
                <textarea onChange={updateReference} value={address.reference || ''} maxLength={150} />
            </label>}
        </div>


        <div className='modal-actions'>
            <button className='secundary-btn modal-address-close-btn' onClick={closeModal}>
                Cerrar
            </button>
            {!resume && <button className={'disabled-btn modal-address-submit-btn' + (address.street && address.number || address.reference && address.reference.length <= 150 ? ' primary-btn ' : '')} onClick={goResume}>
                {isLoading ? <Loader /> : 'Continuar'}
            </button>}

            {resume && <button className={'disabled-btn modal-address-submit-btn' + (address.street && address.number && address.geoCoordinate ? ' primary-btn ' : '')} onClick={saveAddress}>
                {isLoading ? <Loader /> : 'Agregar'}
            </button>}
        </div>
    </form>
};

AddressSelect.propTypes = {
    editAddress: PropTypes.object,
    modal: PropTypes.object
};

export default AddressSelect;
